import styled from 'styled-components';
import { Form } from '@unform/web';
import { Link } from 'react-router-dom';
import colors from '../../styles/colors';

export const Container = styled.section`
  width: 100%;
  min-height: 100vh;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${colors.background.first};
`;

export const Content = styled(Form)`
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  @media screen and (max-width: 768px) {
    padding: 1rem;
    width: 100%;
  }
  & > img {
    width: 50%;
    margin: 1rem 0;
  }
`;

export const ForgotPassword = styled(Link)`
  font-size: 14px;
  font-weight: 400;
  align-self: start;
  transform: translateY(-50%);
  color: ${colors.text.second};
`;

export const PresentationContainer = styled.div`
  width: 100%;
  height: min-content;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  gap: 0.5rem;
  & > h1 {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: ${colors.text.first};
  }

  & > h2 {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: ${colors.text.second};
  }
`;

export const TurnBackContainer = styled(Link)`
  width: 100%;
  height: min-content;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  color: ${colors.text.second};
  text-decoration: underline;
  & > svg {
    width: 1rem;
    height: 1rem;
  }

  &:hover {
    color: ${colors.text.first};
  }
`;
